import { Component, OnInit } from '@angular/core';
import { CertificatesService } from '../services/certificates.service';
import { certificate } from '../model/certificate.modals';
import{ ClipboardService} from 'ngx-clipboard';
import {ToastrService } from 'ngx-toastr'
@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.css']
})
export class CertificatesComponent implements OnInit {
  copyContent:any;
  hasContent:boolean=false;
  isLoading:boolean;
  constructor(private certificateService: CertificatesService,private _clipboardService: ClipboardService ,private toasterService:ToastrService ) { }
  certificateModal: certificate = new certificate();
  ngOnInit() {
    this.isLoading=true
    localStorage.setItem('option','certificate');
    this.certificateService.getCertificate().subscribe((res) => {
      this.certificateModal = res as certificate;
      if(Object.keys(this.certificateModal.data).length==0 )
      {
        this.hasContent=true;
        this.certificateModal.data='No certificate data available';
      }
      this.isLoading=false
    }, error => {
      this.isLoading=false
      alert(JSON.stringify(error));
    });
  }
  recieveCertificateFromAddComponent($event) {

    this.certificateModal.data = $event;
  }
  saveAs() {
    var blob = new Blob([this.certificateModal.data], { type: 'text/csv' });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, 'certificate.key');
    }
    else {
      var elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = 'certificate.key';
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  }

  callServiceToCopy() {
   if(this._clipboardService.copyFromContent(this.certificateModal.data)){
    this.toasterService.success('Public key copied!','copied!',);
   }else
        this.toasterService.error('Error in coping!','Error!');
}
}
